
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3b99"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3b99"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5iCX9", function(module, exports) {

$parcel$export(module.exports, "setAnalyticsData", function () { return $3dbcd96e047eff80$export$49528889758b3022; });
(function(c, l, a, r, i, t, y) {
    c[a] = c[a] || function() {
        (c[a].q = c[a].q || []).push(arguments);
    };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    t.onerror = function() {
        console.error("Microsoft Clarity script failed to load");
    };
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
})(window, document, "clarity", "script", "ns99iv1fsm");
// Function to set the data
function $3dbcd96e047eff80$export$49528889758b3022(organization, member, board) {
    if (window.clarity) {
        clarity("set", "organization", organization);
        clarity("set", "member", member);
        clarity("set", "board", board);
    } else console.error("Clarity is not initialized yet.");
}

});


parcelRequire("5iCX9");

//# sourceMappingURL=authorize.f971f66f.js.map
